import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["innerHTML"]

import TooltipInfo from '@/brief-hub/common/ui/components/TooltipInfo.vue';
    import BriefHubStepLayout from '@/brief-hub/common/ui/layout/BriefHubStepLayout.vue';
    import store from '@/brief-hub/store';
    import {MutationsType} from '@/brief-hub/store/modules/brief/mutations';
    import type {BriefWhenConditions, BriefWhereConditions, Payload} from '@/brief-hub/store/modules/brief/types';
    import {useConnectedUserStore} from '@/brief-hub/stores/connectedUser.store';
    import UserResource from '@/brief-hub/user/UserResource';
    import {FreelancerAvailability, WhereConditionsBriefRequest, WorkingStatusRequest} from '@/common/api/api-raw-types';
    import RemoteChoices from '@/common/components/remote-choices/RemoteChoices.vue';
    import {WORKED_DAYS_MAPPING} from '@/common/config/variables';
    import {useGlobalProperties} from '@malt/vue3-use';
    import {Ref, computed, onMounted, ref, watch, inject} from 'vue';
    import {BriefTrackingService} from '@/brief-hub/brief/BriefTrackingService';
    import {DI} from '@/brief-hub/config/DependencyInjection';
    import {useRouter} from 'vue-router';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'BriefConditionsWhereV2',
  setup(__props) {

    const {$features} = useGlobalProperties();
    const briefTrackingService = inject<BriefTrackingService>(DI.briefTrackingService);
    const $router = useRouter();

    const initialized: Ref<boolean> = ref(false);

    const briefWhenConditions: Ref<BriefWhenConditions> = ref(store.getters.briefWhenConditions);
    const briefWhereConditions: Ref<BriefWhereConditions> = ref(store.getters.briefWhereConditions);

    const connectedUserStore = useConnectedUserStore();
    const user = computed<UserResource | null>(() => connectedUserStore.user);

    const locatedCompanyBillingAddress = user.value?.currentIdentity?.locatedCompanyBillingAddress;
    const remoteChoices = ref<WhereConditionsBriefRequest>({
        address: briefWhereConditions.value.address?.formattedAddress
            ? briefWhereConditions.value.address
            : locatedCompanyBillingAddress ?? undefined,
        remote: briefWhereConditions.value.remote ?? undefined,
        remoteFrequency: briefWhereConditions.value.remoteFrequency ?? undefined,
        workingStatus: briefWhereConditions.value.workingStatus
            ? WorkingStatusRequest[briefWhereConditions.value.workingStatus]
            : WorkingStatusRequest.REMOTELY,
    });

    const frequencyLimit = computed<number | undefined>(() => {
        if (
            briefWhenConditions.value.projectDuration &&
            briefWhenConditions.value.projectDuration.value < 5 &&
            briefWhenConditions.value.projectDuration.unit === 'DAYS'
        ) {
            let freelancerAvailability = FreelancerAvailability.FULL_TIME;
            switch (briefWhenConditions.value.projectDuration.value) {
                case 2:
                    freelancerAvailability = FreelancerAvailability.TWO_DAYS_PER_WEEK;
                    break;
                case 3:
                    freelancerAvailability = FreelancerAvailability.THREE_DAYS_PER_WEEK;
                    break;
                case 4:
                    freelancerAvailability = FreelancerAvailability.FOUR_DAYS_PER_WEEK;
                    break;
            }
            return WORKED_DAYS_MAPPING[freelancerAvailability];
        }

        if (briefWhenConditions.value.freelancerAvailability) {
            return WORKED_DAYS_MAPPING[briefWhenConditions.value.freelancerAvailability];
        }
        return undefined;
    });

    const hideHybrid = computed<boolean>(
        () => briefWhenConditions.value.projectDuration?.value === 1 && briefWhenConditions.value.projectDuration?.unit === 'DAYS',
    );

    const isValidateForm = ref<boolean>(false);

    function handleUpdateChoices(value: WhereConditionsBriefRequest, valid: boolean) {
        remoteChoices.value = {
            address: value.address,
            remote: value.remote,
            remoteFrequency: value.remoteFrequency,
            workingStatus: value.workingStatus || WorkingStatusRequest.REMOTELY,
        };
        isValidateForm.value = valid;
    }

    function onFormChange(): void {
        let payload: Payload | null = null;
        if (isValidateForm.value) {
            payload = {
                type: 'WhereConditionsBriefRequest',
                // @ts-ignore
                payload: remoteChoices.value,
            };
        }
        store.commit(MutationsType.UPDATE_PAYLOAD, payload);
        if (initialized.value) {
            store.commit(MutationsType.UPDATE_BRIEF_FORM_WHEN, remoteChoices.value);
        }
    }

    onMounted(() => {
        briefTrackingService?.triggerBriefFunnelStepEnteredAmplitudeEvent('condition_where', 4, $router.currentRoute.value);
    });

    watch(remoteChoices, onFormChange, {immediate: true});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(BriefHubStepLayout, null, {
      right: _withCtx(() => [
        _createVNode(TooltipInfo, {
          icon: "megaphone",
          title: _ctx.$msg('customer.brief.form.tooltip.title')
        }, {
          content: _withCtx(() => [
            _createElementVNode("p", {
              innerHTML: _ctx.$msg('customer.brief.form.conditions.where.tooltip')
            }, null, 8, _hoisted_1)
          ]),
          _: 1
        }, 8, ["title"])
      ]),
      title: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$msg('customer.brief.form.conditions.where.title.v2')), 1)
      ]),
      default: _withCtx(() => [
        _createVNode(RemoteChoices, {
          choices: remoteChoices.value,
          "frequency-limit": frequencyLimit.value,
          "hide-hybrid": hideHybrid.value,
          "onUpdate:choices": handleUpdateChoices
        }, null, 8, ["choices", "frequency-limit", "hide-hybrid"])
      ]),
      _: 1
    })
  ]))
}
}

})